import { environment } from "../environment";

// Create our number formatter.
const formatterUSD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const formatterEUR = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
});

const formatterCHF = new Intl.NumberFormat('de-CH', {
    style: 'currency',
    currency: 'CHF',
});

const formatterHRK = new Intl.NumberFormat('hr-HR', {
    style: 'currency',
    currency: 'HRK',
});


const formatter = {
    'USD': formatterUSD,
    'EUR': formatterEUR,
    'CHF': formatterCHF,
    "HRK": formatterHRK
}

export class CurrencyUtil {

    static formatAsCurrency(amount, currency = environment.currency || 'CHF') {
        return formatter[currency].format(amount)
    }
    static formatAsNumber(amount, currency = 'CHF') {
        return formatter[currency].format(amount).replace("CHF", "").trim()
    }

    //https://stackoverflow.com/questions/50650503/get-the-currency-symbol-for-a-locale
    //getCurrencySymbol('en-US', 'CNY') // CN¥
    //getCurrencySymbol('zh-CN', 'CNY') // ￥
    static getCurrencySymbol = (locale, currency) => (0).toLocaleString(locale, { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, '').trim()

}